import { QueryClient } from '@tanstack/react-query'

import type { DefaultOptions } from '@tanstack/react-query'

const defaultQueryOptions: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
  },
}

export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
})
